/* Giftera – blocuri vizuale pe pagina de produs (portat din tema live; decizia 12)
   - zoom „De aproape”: întreg → lanț (oțel inoxidabil) → pietre (zirconiu), în buclă, doar când e vizibil
   - rândul de modele: construit din <gf-model-picker> (aflat în altă secțiune a paginii); alegerea se face
     prin picker.choose(tile), deci în coș pleacă aceleași proprietăți
   Scoase față de live: „Cum stă la gât” și „Cardul: mesajul nostru sau al tău” (cu butonul „Personalizează cardul”). */
(function () {
  if (window.__gfVz) return;
  window.__gfVz = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initZoom(z) {
    if (z.__gfZoomReady) return;
    z.__gfZoomReady = true;
    var steps, hold;
    try { steps = JSON.parse(z.getAttribute('data-steps')); } catch (e) { return; }
    hold = (z.getAttribute('data-hold') || '1800,2800,2800').split(',').map(Number);
    var stage = z.querySelector('.gf-vz__zoom');
    var img = z.querySelector('.gf-vz__zoom img');
    var chip = z.querySelector('.gf-vz__zchip');
    var labs = z.querySelectorAll('.gf-vz__zlab');
    var tabs = z.querySelectorAll('.gf-vz__ztabs button');
    var cur = 0, timer = null, visible = false, MOVE = 1300;
    if (!stage || !img || !steps || !steps.length) return;

    function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
    function dwell(i) { return hold[i] + (i === 0 ? 0 : MOVE); }
    function show(i) {
      cur = i;
      var st = steps[i], s = st.s;
      var tx = clamp(50 - st.x * s * 100, 100 - s * 100, 0);
      var ty = clamp(50 - st.y * s * 100, 100 - s * 100, 0);
      img.style.transform = 'translate(' + tx + '%,' + ty + '%) scale(' + s + ')';
      labs.forEach(function (l) { l.classList.toggle('is-on', +l.getAttribute('data-step') === i); });
      if (chip) chip.classList.toggle('is-off', i !== 0);
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-pressed', k === i ? 'true' : 'false');
        t.classList.remove('is-run');
        if (k === i && !reduce && visible) {
          t.style.setProperty('--d', dwell(i) + 'ms');
          void t.offsetWidth;
          t.classList.add('is-run');
        }
      });
    }
    function schedule() {
      clearTimeout(timer);
      if (reduce || !visible) return;
      timer = setTimeout(function () { show((cur + 1) % steps.length); schedule(); }, dwell(cur));
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(+t.getAttribute('data-go')); schedule(); });
    });
    show(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.isIntersecting && e.intersectionRatio >= 0.5;
          if (v && !visible) { visible = true; show(cur); schedule(); }
          else if (!v && visible) { visible = false; clearTimeout(timer); }
        });
      }, { threshold: [0, 0.5, 1] }).observe(stage);
    } else { visible = true; schedule(); }
  }

  function initModels(root) {
    if (root.__gfModelsReady) return;
    var sec = root.querySelector('[data-gf-vz-models]');
    var rail = root.querySelector('[data-gf-vz-rail]');
    if (!sec || !rail) return;
    /* selectorul stă în secțiunea giftera-product, nu lângă acest bloc */
    var picker = document.querySelector('gf-model-picker');
    if (!picker) return;
    var ptiles = Array.prototype.slice.call(picker.querySelectorAll('.gf-mp__tile'));
    if (!ptiles.length) return;
    root.__gfModelsReady = true;

    var map = {};
    try { map = JSON.parse(root.querySelector('[data-gf-vz-nk]').textContent) || {}; } catch (e) {}
    var codeInput = picker.querySelector('input[data-gf-code]');
    var valueInput = picker.querySelector('input[data-gf-value]');
    var altPrefix = sec.getAttribute('data-alt-prefix') || '';

    var mine = ptiles.map(function (pt) {
      var code = pt.getAttribute('data-code') || '';
      var name = pt.getAttribute('data-value') || '';
      var pimg = pt.querySelector('img');
      var src = map[code] || (pimg && (pimg.currentSrc || pimg.src)) || '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gf-vz__tile';
      b.setAttribute('data-code', code);
      b.setAttribute('aria-pressed', 'false');
      var im = document.createElement('span'); im.className = 'gf-vz__im';
      if (src) {
        var img = document.createElement('img');
        img.src = src; img.alt = (altPrefix ? altPrefix + ' ' : '') + name; img.loading = 'lazy'; img.decoding = 'async';
        img.width = 320; img.height = 320;
        im.appendChild(img);
      }
      var nm = document.createElement('span'); nm.className = 'gf-vz__nm'; nm.textContent = name;
      b.appendChild(im); b.appendChild(nm);
      b.addEventListener('click', function () {
        if (typeof picker.choose === 'function') picker.choose(pt); else pt.click();
        sync();
      });
      rail.appendChild(b);
      return b;
    });
    if (mine.length <= 3) rail.classList.add('gf-vz__rail--few');

    function sync() {
      var code = codeInput ? codeInput.value : '';
      var val = valueInput ? valueInput.value : '';
      mine.forEach(function (b, i) {
        var pt = ptiles[i];
        var on = code ? b.getAttribute('data-code') === code : pt.getAttribute('data-value') === val;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (valueInput) valueInput.addEventListener('change', sync);
    ptiles.forEach(function (pt) { pt.addEventListener('click', function () { setTimeout(sync, 0); }); });
    sync();

    /* titlul vine din Liquid cu numărul calculat pe server; aici doar se aliniază la numărul real de tile-uri */
    var tpl = sec.getAttribute('data-title');
    var h = sec.querySelector('.gf-sh__title');
    if (h && tpl) h.textContent = tpl.replace('[numar]', String(mine.length));
    sec.hidden = false;
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-gf-vz]'));
  }

  function initZooms() {
    roots().forEach(function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-gf-zoom]'), initZoom);
    });
  }

  function initAllModels() {
    roots().forEach(initModels);
  }

  function start() {
    initZooms();
    if (!document.querySelector('gf-model-picker')) return;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('gf-model-picker').then(initAllModels, initAllModels);
      /* dacă scriptul selectorului nu se încarcă, rândul se construiește oricum (clic → tile.click()) */
      setTimeout(initAllModels, 1500);
    } else {
      initAllModels();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* editorul de temă: secțiunea se reîncarcă fără reîncărcarea paginii */
  document.addEventListener('shopify:section:load', start);
})();
